import { UseProductLinkType } from './types'
import { StateType } from '~/hooks/use-link-state'

import urls from '~/common/urls'

export const useProductLink = ({
  product,
  currentVariant,
  collectionHandle,
}: UseProductLinkType) => {
  let linkProps: Record<string, StateType> = {}

  const isRunnerOrCircular = product.isRunnerOrCircularRug

  if (isRunnerOrCircular) {
    linkProps = {
      ...linkProps,
      state: {
        ...linkProps.state,
        comesFromRunners: collectionHandle === 'runners',
        comesFromCircular: collectionHandle === 'circular',
      },
    }
  }

  if (collectionHandle && collectionHandle.indexOf('sale') >= 0) {
    linkProps = {
      ...linkProps,
      state: {
        ...linkProps.state,
        comesFromSaleCollections: true,
      },
    }
  }

  if (product.inStockColorOption) {
    linkProps = {
      ...linkProps,
      state: {
        ...linkProps.state,
        inStockColorOption: product.inStockColorOption,
      },
    }
  }

  let productLink = `${urls.pages.productDetail}/${product.handle}`

  if (currentVariant) {
    const [, id] = currentVariant.id.split('/ProductVariant/')
    productLink = `${productLink}?variant=${id}`
  }

  if (product.inStockVariantId) {
    productLink = `${productLink}?variant=${product.inStockVariantId}`
  }

  return {
    linkProps,
    productLink,
  }
}
